const PRESETS = {
  production: {
    showLogin: true,
    showGuestLogin: false,
    themeSwitcher: false,
    analytics: true,
  },
  beta: {
    showLogin: true,
    showGuestLogin: false,
    themeSwitcher: true,
    analytics: false,
  },
  development: {
    showLogin: true,
    showGuestLogin: false,
    themeSwitcher: true,
    analytics: false,
  },
} as const;

type Environment = keyof typeof PRESETS;

const env = (import.meta.env.VITE_FEATURE_ENV || 'production') as Environment;

export const features = PRESETS[env] ?? PRESETS.production;
